<ng-template #mainContent>
  <ng-container *ngIf="title; else customContent">
    <span class="main-content" [class.top-level]="_.topLevel">
      {{ title }}
      <riv-icon
        *ngIf="locked"
        class="lock-icon"
        [name]="'Lock'"
        size="16"
      ></riv-icon>
      <div *ngIf="_.hasChildren && !_.topLevel" class="submenu-icon">
        <riv-icon [name]="'ChevronRight'" size="16"></riv-icon>
      </div>
    </span>
  </ng-container>
  <ng-template #customContent>
    <ng-content select="[custom]"></ng-content>
  </ng-template>
</ng-template>

<ng-container *ngIf="url">
  <a
    *ngIf="_.isFullUrl"
    class="target"
    [class.current]="_.current"
    [class.locked]="locked"
    [attr.href]="url"
    [attr.target]="newTab ? '_blank' : null"
    (click)="_.closeTree(); _.click($event)"
  >
    <ng-container *ngTemplateOutlet="mainContent"></ng-container>
  </a>
  <a
    *ngIf="!_.isFullUrl"
    class="target"
    [class.current]="_.current"
    [class.open]="_.open"
    [class.locked]="locked"
    [rivetLink]="url"
    [locked]="locked"
    [attr.target]="newTab ? '_blank' : null"
    (click)="_.closeTree(); _.click($event)"
  >
    <ng-container *ngTemplateOutlet="mainContent"></ng-container>
  </a>
</ng-container>

<ng-container *ngIf="!url">
  <button
    class="target"
    [class.current]="_.current"
    [class.open]="_.open"
    [class.locked]="locked"
    [disabled]="locked"
    (click)="_.hasChildren ? _.setOpen(true) : _.closeTree(); _.click($event)"
    #anchor
  >
    <ng-container *ngTemplateOutlet="mainContent"></ng-container>
  </button>
  <ng-container *ngIf="_.open">
    <riv-callout
      *riv-overlay
      [anchor]="anchor"
      [theme]="'light'"
      [showCaret]="false"
      [preferredPosition]="
        menuPreferredPosition ?? (_.topLevel ? 'bottom-right' : 'right-top')
      "
      (close)="_.setOpen(false)"
    >
      <div class="children">
        <ng-content></ng-content>
      </div>
    </riv-callout>
  </ng-container>
</ng-container>
